// eslint-disable-next-line import/prefer-default-export
export const AI_MARATHON_1_START_DATE = new Date('2024-08-20T10:00:00').getTime();
export const AI_MARATHON_1_END_DATE = new Date('2024-09-05T16:00:00').getTime();
